import { Logo } from '../../components/design-system';
import { REVEAL_EASE } from './AuthLayout';
import peopleAtTableUrl from '../../assets/illustrations/peopleattable_sekretly.svg?url';

export interface AuthHeaderProps {
  reducedMotion: boolean;
}

/**
 * Shared header for the login/register screens — illustration, small logo
 * mark, centered "Welcome in town" headline. Same on both; only what's below
 * it differs.
 *
 * The entrance is pure CSS keyframes with staggered `animation-delay` (see
 * AuthLayout's KEYFRAMES) rather than JS-driven state, so nothing here
 * re-renders after mount: the illustration rises in first, the logo settles
 * with a faint scale, then the headline rises in line by line.
 */
export function AuthHeader({ reducedMotion }: AuthHeaderProps) {
  return (
    <div className="flex flex-col items-center text-center">
      <img
        src={peopleAtTableUrl}
        alt=""
        className="w-full max-w-[300px] mb-6"
        style={{ animation: reducedMotion ? undefined : `sk-rise 420ms ${REVEAL_EASE} both` }}
      />
      <Logo
        variant="full"
        height={22}
        style={{
          color: 'rgb(var(--cream-bright))',
          animation: reducedMotion ? undefined : `sk-fade-scale 240ms ${REVEAL_EASE} 160ms both`,
        }}
      />
      <h1
        className="font-serif mt-2.5"
        style={{
          fontSize: 'var(--fs-page-title)',
          lineHeight: 'var(--lh-page-title)',
          letterSpacing: '-0.03em',
          color: 'rgb(var(--cream-bright))',
        }}
      >
        <span
          style={{
            display: 'inline-block',
            animation: reducedMotion ? undefined : `sk-rise 320ms ${REVEAL_EASE} 240ms both`,
          }}
        >
          Welcome
        </span>
        <br />
        <span
          style={{
            display: 'inline-block',
            animation: reducedMotion ? undefined : `sk-rise 320ms ${REVEAL_EASE} 310ms both`,
          }}
        >
          in town
        </span>
      </h1>
    </div>
  );
}

export default AuthHeader;
